import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  IActionsHorseRequest,
  IAdminChangeHorseStatusRequest,
  IAdminHorsesQueryResponse,
  IHorseFormInformation,
  IHorseQueryRequest,
  IPopulatedHorseWithoutCount,
  IUpdateHorseRequest
} from 'models/horse'
import { getNormalizedFormData } from 'shared/utils/getNormalizedFormData'

export const horsesApi = {
  getHorses({
    skip,
    limit,
    statuses,
    statusOrder
  }: IHorseQueryRequest): Promise<AxiosResponse<IAdminHorsesQueryResponse>> {
    const params = new URLSearchParams({
      skip,
      limit,
      ...(statuses?.length && { status: statuses.join(',') }),
      ...(statusOrder && { status_order: statusOrder })
    })
    return privateApi.get<IAdminHorsesQueryResponse>(
      `admin/horse?${params.toString()}`
    )
  },

  // лошади текущего пользователя (кабинет селлера); архивные нужны, чтобы их можно было переподать
  getMyHorses(includeArchived = true): Promise<AxiosResponse<IPopulatedHorseWithoutCount[]>> {
    return privateApi.get<IPopulatedHorseWithoutCount[]>('horse', {
      params: { limit: '100', ...(includeArchived && { includeArchived: 'true' }) }
    })
  },

  // карточка лошади для владельца или администратора — в любом статусе, включая архив
  getHorseForManage(horseId: string): Promise<AxiosResponse<IPopulatedHorseWithoutCount>> {
    return privateApi.get<IPopulatedHorseWithoutCount>(`horse/${horseId}/manage`)
  },

  getFormInformation(): Promise<AxiosResponse<IHorseFormInformation>> {
    return privateApi.get<IHorseFormInformation>('horse/form-information')
  },

  updateHorse(horseId: string, data: IUpdateHorseRequest): Promise<AxiosResponse> {
    return privateApi.patch(`horse/${horseId}`, getNormalizedFormData(data), {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600000
    })
  },

  republishHorse(horseId: string): Promise<AxiosResponse<IPopulatedHorseWithoutCount>> {
    return privateApi.post<IPopulatedHorseWithoutCount>(`horse/${horseId}/republish`)
  },

  changeHorseStatus(horseId: string, data: IAdminChangeHorseStatusRequest): Promise<AxiosResponse> {
    return privateApi.put(
      `admin/horse/change-status/${horseId}`,
      data
    )
  },
  setActions({
    toDelete
  }: IActionsHorseRequest): Promise<AxiosResponse> {
    const params = new URLSearchParams({
      toDelete: toDelete
    })

    return privateApi.put<void>(`admin/horse/actions?${params.toString()}`)
  }
}
